import { FILE_TYPE, FILE_TYPE_INFO, type FileType } from "@/constants/storage";

function hasExtension(fileName: string, type: FileType): boolean {
  const lower = fileName.toLowerCase();
  return FILE_TYPE_INFO[type].extensions.some((ext) => lower.endsWith(ext));
}

export const isWordFileName = (fileName: string): boolean => hasExtension(fileName, FILE_TYPE.WORD);

export const isSpreadsheetFileName = (fileName: string): boolean =>
  hasExtension(fileName, FILE_TYPE.SPREADSHEET);

export const isImageFileName = (fileName: string): boolean =>
  hasExtension(fileName, FILE_TYPE.IMAGE);

export const isTextFileName = (fileName: string): boolean => hasExtension(fileName, FILE_TYPE.TEXT);

export const isPdfFile = (file: File): boolean =>
  hasExtension(file.name, FILE_TYPE.PDF) || FILE_TYPE_INFO.pdf.mimeTypes.includes(file.type);

export function getFileType(fileName: string | undefined): FileType {
  if (!fileName) return FILE_TYPE.PDF;
  if (isWordFileName(fileName)) return FILE_TYPE.WORD;
  if (isSpreadsheetFileName(fileName)) return FILE_TYPE.SPREADSHEET;
  if (isImageFileName(fileName)) return FILE_TYPE.IMAGE;
  if (isTextFileName(fileName)) return FILE_TYPE.TEXT;
  return FILE_TYPE.PDF; // unrecognized extensions fall back to the PDF viewer
}
